<!-- Dynamic preset + scaled viewport sizes require style bindings (scale-to-fit preview). -->
<!-- eslint-disable @angular-eslint/template/no-inline-styles -->

<div class="preview-toolbar" role="group" [attr.aria-labelledby]="toolbarLabelId">
  <span [id]="toolbarLabelId" class="preview-toolbar-label">Device preview</span>
  <joii-segmented-controller
    [options]="deviceOptions"
    size="md"
    [value]="selectedDeviceId()"
    (valueChange)="onDeviceValueChange($event)"
  ></joii-segmented-controller>
</div>

<div class="preview-stack">
  <section #stage class="preview-stage" aria-label="Responsive preview canvas">
    <div class="preview-stage-inner" [style.padding-bottom.px]="stageBottomPadding()">
      <div class="preview-device-column">
        <div
          class="preview-viewport"
          [style.width.px]="scaledViewportWidth()"
          [style.height.px]="scaledViewportHeight()"
        >
          <div
            class="device-shell"
            [attr.data-device]="selectedDevice().id"
            [attr.data-chrome]="chromeVisible() ? 'true' : 'false'"
            [style.--device-width.px]="selectedDevice().width"
            [style.--device-height.px]="selectedDevice().height"
            [style.--shell-width.px]="shellWidth()"
            [style.--shell-height.px]="shellHeight()"
            [style.--bezel-top.px]="chrome().bezelTop"
            [style.--bezel-right.px]="chrome().bezelRight"
            [style.--bezel-bottom.px]="chrome().bezelBottom"
            [style.--bezel-left.px]="chrome().bezelLeft"
            [style.--preview-scale]="scale()"
          >
            @if (deviceChrome()) {
              <div class="device-chrome" aria-hidden="true">
                <div class="device-chassis">
                  <span class="device-side-btn silent"></span>
                  <span class="device-side-btn vol-up"></span>
                  <span class="device-side-btn vol-down"></span>
                  <span class="device-side-btn power"></span>
                  <span class="device-notch"></span>
                  <span class="device-camera"></span>
                  <span class="device-home-bar"></span>
                </div>
              </div>
            }
            <div class="device-frame" [attr.data-device]="selectedDevice().id">
              <ng-content />
            </div>
          </div>
        </div>
        <div #scaleFooter class="preview-scale-footer" [style.width.px]="scaledViewportWidth()">
          <span joii-text [size]="3" color="inline-link" class="scale-indicator" aria-live="polite"
            >Scale: {{ scalePercent() }}%</span
          >
        </div>
      </div>
    </div>
  </section>
</div>
